import { render, staticRenderFns } from "./GenusIndexManageComponent.vue?vue&type=template&id=675c20c8&scoped=true&"
import script from "./GenusIndexManageComponent.vue?vue&type=script&lang=js&"
export * from "./GenusIndexManageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c20c8",
  null
  
)

export default component.exports